import { createCRUDHook } from './createCRUDHook';
import { TestimonialDto } from 'utils/models';
import { TBL_TESTIMONIAL } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<TestimonialDto>({
  entityName: 'Testimonial',
  endpoint: TBL_TESTIMONIAL,
});

export const TestimonialContext = Context;
export const useTestimonialManager = useManager;
export const useTestimonial = useConsumer;
